import StarsCounter from './StarsCounter';

export default StarsCounter;